export default "__VITE_ASSET__D6flfZbp__"